import { ADMIN_ROOT, APP, routes } from "../../routes/constants/routes"

export const isSidebarVisible = (pathname: string) => {
  return (
    pathname.startsWith(APP) ||
    pathname.startsWith(ADMIN_ROOT) ||
    pathname.startsWith(routes.AUTH.PROFILE)
  )
}
